import dayjs from "dayjs";

export function getParentStatusColor(value) {
    if (value === "SINGLE") return "blue";
    if (value === "PARTIAL") return "orange";
    if (value === "EMPTY") return "default";
    return "default";
}

export function getChildFillTypeColor(value) {
    if (value === "FILLED") return "blue";
    if (value === "UNFILLED") return "default";
    return "default";
}

export function getCheckStatusColor(value) {
    if (value === "PENDING_OUTGOING") return "gold";
    if (value === "COMPLETED_SAME_DAY") return "green";
    if (value === "COMPLETED_LATE") return "orange";
    if (value === "OUTGOING_NOT_FOUND") return "red";
    if (value === "RETURNED_PARTIAL") return "volcano";
    if (value === "RETURNED_FULL") return "red";
    if (value === "VERIFIED_FINAL") return "blue";
    if (value === "RETURN_RESET") return "magenta";
    if (value === "MANUAL_REVIEW") return "purple";
    return "default";
}

export function getCheckStatusLabel(value) {
    if (value === "PENDING_OUTGOING") return "Гарах гүйлгээ хүлээгдэж байна";
    if (value === "COMPLETED_SAME_DAY") return "Тухайн өдөр дууссан";
    if (value === "COMPLETED_LATE") return "Хожуу дууссан";
    if (value === "OUTGOING_NOT_FOUND") return "Гарах гүйлгээ олдсонгүй";
    if (value === "RETURNED_PARTIAL") return "Хэсэгчлэн буцсан";
    if (value === "RETURNED_FULL") return "Бүтэн буцсан";
    if (value === "VERIFIED_FINAL") return "Эцэслэн баталгаажсан";
    if (value === "RETURN_RESET") return "Буцаалттай тул дахин бөглөнө";
    if (value === "MANUAL_REVIEW") return "Гараар шалгах";
    return value || "-";
}

export function getActionColor(value) {
    if (value === "CREATED") return "green";
    if (value === "UPDATED") return "blue";
    if (value === "DELETED") return "red";
    if (value === "AGREED") return "green";
    if (value === "UNAGREED") return "orange";
    return "default";
}

export function getActionLabel(value) {
    if (value === "CREATED") return "Үүсгэсэн";
    if (value === "UPDATED") return "Зассан";
    if (value === "DELETED") return "Устгасан";
    if (value === "AGREED") return "Зөвшөөрсөн";
    if (value === "UNAGREED") return "Зөвшөөрөл цуцалсан";
    return value || "-";
}

export function getParentStatusLabel(value) {
    if (value === "SINGLE") return "Нэг";
    if (value === "PARTIAL") return "Хэсэгчилсэн";
    if (value === "EMPTY") return "Хоосон";
    return value || "-";
}

export function getFillTypeLabel(value) {
    if (value === "FILLED") return "Бөглөсөн";
    if (value === "UNFILLED") return "Бөглөөгүй";
    return value || "-";
}

export function formatDateTime(value) {
    if (!value) return "-";
    return String(value).replace("T", " ");
}

export function isSameDay(value, date) {
    if (!value || !date) return false;
    return dayjs(value).format("YYYY-MM-DD") === dayjs(date).format("YYYY-MM-DD");
}

export function getDayTransactions(transactions, date) {
    return (transactions || []).filter((item) => isSameDay(item.createdAt, date));
}

export function getDayCalendarStats(transactions, date) {
    const rows = getDayTransactions(transactions, date);

    const total = rows.length;
    const unagreed = rows.filter((x) => {
        const totalAlloc = x.allocationCount || 0;
        const agreed = x.agreedAllocationCount || 0;
        return totalAlloc > 0 && agreed < totalAlloc;
    }).length;

    const agreed = rows.filter((x) => {
        const totalAlloc = x.allocationCount || 0;
        const agreedCount = x.agreedAllocationCount || 0;
        return totalAlloc > 0 && agreedCount === totalAlloc;
    }).length;

    const returned = rows.reduce((sum, x) => sum + (x.returnedAllocationCount || 0), 0);
    const outgoingPending = rows.reduce((sum, x) => sum + (x.outgoingPendingAllocationCount || 0), 0);
    const review = rows.reduce((sum, x) => sum + (x.reviewAllocationCount || 0), 0);
    const amountTotal = rows.reduce((sum, x) => sum + Number(x.paymentAmount || 0), 0);

    return {
        rows,
        total,
        unagreed,
        agreed,
        returned,
        outgoingPending,
        review,
        amountTotal,
    };
}

export function renderChangedBlock(oldValue, newValue) {
    const changed =
        oldValue !== newValue &&
        !(oldValue == null && newValue == null);

    return (
        <div style={changed ? { color: "#cf1322", fontWeight: 600 } : {}}>
            <div>Өмнө: {typeof oldValue === "number" ? formatAmount(oldValue) : oldValue ?? "-"}</div>
            <div>Дараа: {typeof newValue === "number" ? formatAmount(newValue) : newValue ?? "-"}</div>
        </div>
    );
}

export function getDayReturnCount(returns, date) {
    return (returns || []).filter((item) => isSameDay(item.transactionDate, date)).length;
}

export function getDayReturns(returns, date) {
    return (returns || []).filter((item) => isSameDay(item.transactionDate, date));
}

export function formatAmount(value, options = {}) {
    if (value === null || value === undefined || value === "") return "-";

    const number = Number(value);
    if (!Number.isFinite(number)) return "-";

    const {
        minimumFractionDigits = 0,
        maximumFractionDigits = 2,
    } = options;

    return number.toLocaleString("en-US", {
        minimumFractionDigits,
        maximumFractionDigits,
    });
}

export function compareText(a, b) {
    return String(a ?? "").localeCompare(String(b ?? ""));
}

export function compareNumber(a, b) {
    return Number(a ?? 0) - Number(b ?? 0);
}

export function compareDate(a, b) {
    const aTime = a ? new Date(a).getTime() : 0;
    const bTime = b ? new Date(b).getTime() : 0;
    return aTime - bTime;
}

export function getUniqueFilterOptions(rows, dataIndex, valueGetter) {
    const map = new Map();

    (rows || []).forEach((row) => {
        const rawValue = valueGetter ? valueGetter(row) : row?.[dataIndex];
        const value = rawValue ?? "";

        if (String(value).trim() !== "") {
            map.set(String(value), {
                text: String(value),
                value: String(value),
            });
        }
    });

    return Array.from(map.values()).sort((a, b) => compareText(a.text, b.text));
}

export function addTextColumnTools(column, rows, dataIndex = column.dataIndex, valueGetter) {
    return {
        ...column,
        sorter: (a, b) => compareText(
            valueGetter ? valueGetter(a) : a?.[dataIndex],
            valueGetter ? valueGetter(b) : b?.[dataIndex]
        ),
        filters: getUniqueFilterOptions(rows, dataIndex, valueGetter),
        filterSearch: true,
        onFilter: (value, record) => {
            const raw = valueGetter ? valueGetter(record) : record?.[dataIndex];
            return String(raw ?? "") === String(value);
        },
    };
}

export function addNumberColumnTools(column, dataIndex = column.dataIndex) {
    return {
        ...column,
        sorter: (a, b) => compareNumber(a?.[dataIndex], b?.[dataIndex]),
    };
}

export function addDateColumnTools(column, dataIndex = column.dataIndex, defaultSortOrder) {
    return {
        ...column,
        sorter: (a, b) => compareDate(a?.[dataIndex], b?.[dataIndex]),
        ...(defaultSortOrder ? { defaultSortOrder } : {}),
    };
}